module.exports = __webpack_public_path__ + "static/media/banner_JORNADAcereales_movil.ed7fe9d6.jpg";